<template>
  <tr class="event-card">
    <td class="is--date">{{ formatDate(event.starttime) }} - {{ formatDate(event.endtime) }}</td>
    <td class="is--company" v-if="event.company.title">{{ event.company.title }}</td>
    <td class="is--address">{{ event.company.zip }} {{ event.company.city }}</td>
    <td class="is--homepage">
      <a
        v-if="event.company.homepage"
        :href="('http' !== event.company.homepage.substr(0, 4) ? 'http://' : '') + event.company.homepage"
        target="_blank"
      >{{ event.company.homepage }}</a>
      <template v-else>-</template>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    event: Object,
  },

  data() {
    return {};
  },

  methods: {
    formatDate(date) {
      if (!date) {
        return '';
      }

      const d = new Date(date);

      return [
        String(d.getDate()).padStart(2, '0'),
        String(d.getMonth() + 1).padStart(2, '0'),
        d.getFullYear(),
      ].join('.');
    }
  }
};
</script>

<style lang="scss">
td.is--homepage {
  a {
    padding: 0;
  }
}

@media (min-width: 786px) {
  td {
    &.is--date,
    &.is--homepage {
      width: 20%;
    }

    &.is--company,
    &.is--address {
      width: 30%;
    }

    &.is--homepage {
      text-align: center;
    }
  }
}

@media (max-width: 786px) {
  td {
    width: 50%;

    &.is--homepage {
      text-align: left;

      a {
        padding: 0;
      }
    }
  }
}

@media (max-width: 400px) {
  td {
    width: 100%;
  }
}
</style>
